export default [
  // *===============================================---*
  // *--------- Delivery Management  ---- ---------------------------------------*
  // *===============================================---*
  {
    path: "/delivery/DeliveryManagement/vehicle",
    name: "vehicle",
    component: () => import("@/views/delivery/DeliveryManagement/Vehicle.vue"),
    meta: {
      pageTitle: "Vehicle",
      breadcrumb: [
        {
          text: "Vehicle",
          active: true,
        },
      ],
    },
  },
  {
    path: "/delivery/DeliveryManagement/gps-device",
    name: "gps-device",
    component: () =>
      import("@/views/delivery/DeliveryManagement/GpsDevice.vue"),
    meta: {
      pageTitle: "GPS Device",
      breadcrumb: [
        {
          text: "GPS Device",
          active: true,
        },
      ],
    },
  },
  {
    path: "/delivery/DeliveryManagement/deliveries",
    name: "deliveries",
    component: () =>
      import("@/views/delivery/DeliveryManagement/Deliveries.vue"),
    meta: {
      pageTitle: "Deliveries",
      breadcrumb: [
        {
          text: "Deliveries",
          active: true,
        },
      ],
    },
  },
  {
    path: "/delivery/DeliveryManagement/AddDelivery/add-delivery",
    name: "add-delivery",
    component: () =>
      import("@/views/delivery/DeliveryManagement/AddDelivery/AddDelivery.vue"),
    meta: {
      pageTitle: "New Delivery",
      breadcrumb: [
        {
          text: "Deliveries",
          to: "/delivery/DeliveryManagement/deliveries",
        },
        {
          text: "New Delivery",
          active: true,
        },
      ],
    },
  },
  {
    path: "/delivery/DeliveryManagement/ViewDelivery/view-delivery/:id",
    name: "view-delivery",
    component: () =>
      import("@/views/delivery/DeliveryManagement/ViewDelivery.vue"),
    meta: {
      pageTitle: "View Delivery",
      breadcrumb: [
        {
          text: "Deliveries",
          to: "/delivery/DeliveryManagement/deliveries",
        },
        {
          text: "View Delivery",
          active: true,
        },
      ],
    },
  },
  {
    path: "/delivery/DeliveryManagement/EditDelivery/edit-delivery/:id",
    name: "edit-delivery",
    component: () =>
      import("@/views/delivery/DeliveryManagement/EditDelivery.vue"),
    meta: {
      pageTitle: "Edit Delivery",
      breadcrumb: [
        {
          text: "Deliveries",
          to: "/delivery/DeliveryManagement/deliveries",
        },
        {
          text: "Edit Delivery",
          active: true,
        },
      ],
    },
  },
  {
    path: "/delivery/DeliveryMonitoring/plan/calendar",
    name: "monitor-delivery",
    component: () =>
      import("@/views/delivery/monitoring/Calendar.vue"),
    meta: {
      pageTitle: "Monitor Deliveries",
      breadcrumb: [
        {
          text: "Deliveries",
          to: "/delivery/DeliveryManagement/deliveries",
        },
        {
          text: "View Delivery",
          active: true,
        },
      ],
    },
  },
];
